import { TiptapContentResolver } from "./../../toolbars-v3/ContentResolver.js";
const getNodeTextWrap = TiptapContentResolver.create((_, __, editor) => {
  const node = editor?.state?.selection?.node;
  if (node) {
    return node.attrs?.containerData?.textWrap;
  } else {
    return void 0;
  }
});
export {
  getNodeTextWrap
};
//# sourceMappingURL=get-node-text-wrap.js.map
